'use client'
import type { PDPAsset } from 'cf-grpc/creativefabrica/content/v1/types_pb'
import { AssetType, AssetVariant } from 'cf-grpc/creativefabrica/content/v1/types_pb'
import { defaultLanguage } from 'cf-i18n/constants'
import Image from 'next/image'
import { tw } from 'utils/classnames'
import { rootPath } from '@repo/web-utils/root-path'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { useHasAllAccessQuery } from '@repo/cf-user/hooks/use-user-data'

import { LFS_URL, NEXT_PUBLIC_CONTENT_IMAGES_ROOT_URL } from '@web/utils/env'
import { LikeButton } from './like-button'
import { ShareOption } from './share-item'

interface ShareOptionsProps {
  productContent: {
    slug: string
    id: string
    assets: PDPAsset[]
    description: string
  }
  className?: string
  locale: string
}

export function ShareOptions({ productContent, className, locale }: ShareOptionsProps) {
  const url = `${rootPath}${locale === defaultLanguage ? '' : `/${locale}`}${AppRoutes.PROD}${
    productContent?.slug ? productContent.slug : ''
  }-${productContent?.id}/`
  const productImgPath = productContent?.assets
    .filter(asset => asset.isPublic && asset.type === AssetType.PREVIEW)
    .find(asset => asset.variant === AssetVariant.DESKTOP)?.filePath
  const productDescription = productContent?.description
  const { data: hasAllAccess } = useHasAllAccessQuery()

  const shouldHideSocialButton = !hasAllAccess
  return (
    <div className={tw('absolute right-4 top-4 z-20 flex flex-col gap-2', className)}>
      {productContent?.id ? <LikeButton productId={productContent.id} /> : null}
      {!shouldHideSocialButton ? (
        <ShareOption
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          title="Share on Facebook"
          icon={
            <Image
              src={`${LFS_URL}/web/pages/content/pdp/share/facebook.svg`}
              alt="facebook"
              width={24}
              height={24}
              unoptimized
            />
          }
        />
      ) : null}
      {!shouldHideSocialButton ? (
        <ShareOption
          href={`https://www.pinterest.com/pin/create/button/?url='${url}&media=${`${NEXT_PUBLIC_CONTENT_IMAGES_ROOT_URL}/${productImgPath}`}&description='${productDescription}`}
          title="Share on Pinterest"
          icon={
            <Image
              src={`${LFS_URL}/web/pages/content/pdp/share/pinterest.svg`}
              alt="pinterest"
              width={24}
              height={24}
              unoptimized
            />
          }
        />
      ) : null}
    </div>
  )
}
